import { Flex, Box, Text, Circle } from "@chakra-ui/react";
import {
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
} from "../../../../../utils/colors";
import { useTranslation } from "react-i18next";

const PermissionToggleBox = ({ section, isChecked, onToggle, label }) => {
  const { t } = useTranslation();

  //   console.log("section", section);
  //   console.log("label", label);

  return (
    <>
      <Flex
        align="center"
        onClick={onToggle}
        _hover={{ cursor: "pointer" }}
        // gap="0.5rem"
        p="0.5rem 0"
      >
        <Flex
          align="center"
          justify="center"
          w="1rem"
          h="1rem"
          borderRadius="10rem"
          border={
            isChecked ? `1px solid ${primaryAlt}` : `1px solid ${newBorder}`
          }
          mr={2}
        >
          {isChecked && <Circle w="0.5rem" h="0.5rem" bg={primaryAlt} />}
        </Flex>

        <Text
          fontWeight="500"
          fontSize="sm"
          color={isChecked ? textPrimary : textSecondary}
          _hover={{
            color: isChecked ? textPrimary : primaryAlt,
          }}
        >
          {" "}
          {t(`permission.${section}-${label}`) || t(label)}
        </Text>
      </Flex>

      {/* 


 <Box
      onClick={onToggle}
      border="1px solid"
      borderColor={isChecked ? "blue.400" : "gray.300"}
      bg={isChecked ? "blue.50" : "gray.50"}
      color={isChecked ? "blue.700" : "gray.600"}
      px={3}
      py={2}
      borderRadius="md"
      cursor="pointer"
      _hover={{ bg: isChecked ? "blue.100" : "gray.100" }}
      fontSize="sm"
      fontWeight="medium"
    >
      {label}
    </Box> */}
    </>
  );
};

export default PermissionToggleBox;
